
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 104 104","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M43.1 91.367c23.803 0 43.1-19.296 43.1-43.1 0-23.803-19.297-43.099-43.1-43.099-23.804 0-43.1 19.296-43.1 43.1 0 23.803 19.296 43.1 43.1 43.1z","fill":"#FDB441"}}),_c('path',{attrs:{"d":"M43.1 82.938c19.148 0 34.67-15.523 34.67-34.67 0-19.148-15.522-34.67-34.67-34.67-19.148 0-34.67 15.522-34.67 34.67 0 19.147 15.522 34.67 34.67 34.67z","fill":"#FEDF30"}}),_c('path',{attrs:{"d":"M21.68 48.267c0-16.881 12.072-30.945 28.05-34.037a34.896 34.896 0 00-6.63-.632c-19.148 0-34.67 15.522-34.67 34.67 0 19.147 15.522 34.67 34.67 34.67 2.266 0 4.48-.22 6.625-.635C33.746 79.21 21.68 65.149 21.68 48.268z","fill":"#FED402"}}),_c('path',{attrs:{"d":"M79.999 50.186c13.258 0 24.006 10.894 24.001 24.333-.005 13.467-10.942 24.313-24.23 24.313H48.506c-9.173 0-16.744-7.465-16.775-16.76-.03-9.315 7.41-16.876 16.595-16.876 2.51 0 4.891.565 7.024 1.577a1.61 1.61 0 002.205-.901c3.437-9.17 12.188-15.686 22.443-15.686z","fill":"#F9F3F1"}}),_c('path',{attrs:{"d":"M39.297 87.25c-.03-9.315 7.411-16.876 16.595-16.876 2.51 0 4.891.565 7.025 1.577a1.61 1.61 0 002.204-.901c3.437-9.17 12.188-15.686 22.443-15.686 3.334 0 6.509.689 9.394 1.934-4.342-4.395-10.338-7.112-16.96-7.112-10.254 0-19.005 6.516-22.442 15.686a1.61 1.61 0 01-2.205.901 16.345 16.345 0 00-7.024-1.577c-9.184 0-16.626 7.56-16.595 16.876.024 7.422 4.857 13.677 11.473 15.896a16.742 16.742 0 01-3.908-10.718z","fill":"#F3EAE6"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h104v104H0z"}})])])])
          )
        }
      }
    